import React, { Component } from "react";
import {
    Row,
    Col
} from "reactstrap";

import AnalyticsChartConsumption from "./Charts/Consumption";
import AnalyticsChartConsumption100 from "./Charts/Consumption100";
import AnalyticsEcoPeriodCard from "./EcoPeriodCard";
import Heatmap from "./Charts/Heatmap";


class AnalyticsConsumption extends Component{
    constructor(props){
        super(props);

        this.state = {

        };
    }

    render(){
        return (
            <div>
                <Row>
                    <Col md="12">
                        <h2 className="ty-subtitle">Mes &eacute;conomies</h2>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" sm="4" lg="3">
                        <AnalyticsEcoPeriodCard type="co2" analytics={true} />
                    </Col>
                    <Col xs="12" sm="4" lg="3">
                        <AnalyticsEcoPeriodCard type="euro" analytics={true} />
                    </Col>
                    <Col xs="12" sm="4" lg="3">
                        <AnalyticsEcoPeriodCard type="time" analytics={true} />
                    </Col>
                    <Col xs="12" sm="0" lg="3">
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" sm="12" lg="12">
                        <Heatmap />
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" sm="12" lg="12">
                        <AnalyticsChartConsumption100 />
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" sm="12" lg="6">
                        <AnalyticsChartConsumption />
                    </Col>
                </Row>
            </div>
        );
    }
}


AnalyticsConsumption.defaultProps = {

};

export default AnalyticsConsumption;



// WEBPACK FOOTER //
// ./src/components/Analytics/Consumption.js